export default "__VITE_ASSET__BbMz4e$H__"